export default __webpack_public_path__ + "98fe077348ff6083c3e8cd1092487355.png";